<template>
  <div>
    <header role="tab" class="card-header">
      <h6 class="m-0">Cartas Pax enviadas</h6>
    </header>
    <div class="row" style="max-height: 400px; overflow:auto;">
      <loading
        :active.sync="loading"
        color="#556ee6"
        loader="dots"
        :can-cancel="false"
        :is-full-page="false"
      />
      <div class="col-lg-12">
        <div v-if="!loading && sends.length === 0" class="text-muted text-center py-3">
          Nenhuma Carta Pax registrada para este participante.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead style="border: none !important">
              <tr>
                <th width="32%" style="border-top: none !important">Template</th>
                <th width="15%" style="border-top: none !important">Status</th>
                <th width="20%" style="border-top: none !important">Enviado em</th>
                <th width="20%" style="border-top: none !important">Entregue em</th>
                <th width="13%" style="border-top: none !important">Erro</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="send in sends" :key="send.id">
                <td>{{ send.template ? send.template.name : '—' }}</td>
                <td>
                  <span class="badge" :class="'badge-cp-' + send.status">
                    {{ statusLabel(send.status) }}
                  </span>
                </td>
                <td class="font-size-11">
                  <span v-if="send.sent_at">{{ $moment(send.sent_at).format('DD/MM/YYYY HH:mm') }}</span>
                  <span v-else class="text-muted">{{ $moment(send.created_at).format('DD/MM/YYYY HH:mm') }}</span>
                </td>
                <td class="font-size-11">
                  <span v-if="send.delivered_at" class="text-success">
                    <i class="bx bx-check-circle"></i>
                    {{ $moment(send.delivered_at).format('DD/MM/YYYY HH:mm') }}
                  </span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td class="font-size-11">
                  <span
                    v-if="send.error_message"
                    v-b-tooltip.hover
                    :title="send.error_message"
                    class="text-danger"
                  >
                    <i class="bx bx-error-circle"></i> Ver erro
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import http from '@/http'

export default {
  name: 'CartaPaxSends',
  components: { Loading },
  props: {
    idParticipant: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      loading: true,
      sends: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      http.get('/admin/participants/' + this.idParticipant + '/carta-pax-sends')
        .then(res => {
          this.sends = (res.data && res.data.data) || []
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    statusLabel (status) {
      var labels = {
        queued: 'Na fila',
        sent: 'Entregue',
        failed: 'Falhou',
        bounced: 'Bounce',
        superseded: 'Substituído'
      }
      return labels[status] || status
    }
  }
}
</script>

<style scoped>
.badge {
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
}
.badge-cp-sent { background: #e8f5e9; color: #2e7d32; }
.badge-cp-queued { background: #fff8e1; color: #b26a00; }
.badge-cp-failed,
.badge-cp-bounced { background: #ffebee; color: #c62828; }
.badge-cp-superseded { background: #f3e5f5; color: #7b1fa2; }
</style>
